import { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { api, errMsg } from "@/lib/api";
import { inputCls } from "@/pages/Login";
import Timeline from "@/components/Timeline";

export default function TimelinePanel({ wedding, onSaved }) {
  const [ms, setMs] = useState([]);
  const [sections, setSections] = useState([]);
  const load = () => api.get(`/manage/weddings/${wedding.id}/timeline`).then((r) => { setMs(r.data.milestones); setSections(r.data.sections); });
  useEffect(() => { load(); }, [wedding.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const upd = (i, k, v) => setMs(ms.map((m, j) => (j === i ? { ...m, [k]: v } : m)));
  const save = async () => {
    try { await api.put(`/manage/weddings/${wedding.id}/timeline`, { milestones: ms }); toast.success("Časovnica je shranjena."); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  const toggle = async (k, v) => {
    try { const r = await api.patch(`/manage/weddings/${wedding.id}`, { settings: { [k]: v } }); onSaved(r.data); } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="grid lg:grid-cols-[22rem_1fr] gap-6" data-testid="timeline-panel">
      <div className="space-y-6">
        <div className="card-lux p-6 space-y-3">
          <h3 className="font-display text-2xl">Časovnica poroke</h3>
          {[["timeline_enabled", "Časovnica vklopljena"], ["timeline_public", "Vidna gostom"]].map(([k, l]) => (
            <div key={k} className="flex items-center justify-between text-sm"><span>{l}</span><Switch checked={!!wedding.settings[k]} onCheckedChange={(v) => toggle(k, v)} data-testid={`timeline-toggle-${k}`} /></div>
          ))}
          <p className="text-xs text-[#6C6560]">Fotografije razvrstimo po času zajema (EXIF), če je na voljo, sicer po času nalaganja.</p>
        </div>
        <div className="card-lux p-6 space-y-3">
          <h3 className="font-display text-xl">Mejniki dneva</h3>
          {ms.map((m, i) => (
            <div key={m.id || i} className="flex gap-2" data-testid="timeline-milestone-row">
              <input type="time" className={`${inputCls} w-28 px-2`} value={m.time} onChange={(e) => upd(i, "time", e.target.value)} data-testid="timeline-milestone-time" />
              <input className={inputCls} value={m.title} maxLength={60} onChange={(e) => upd(i, "title", e.target.value)} data-testid="timeline-milestone-title" />
              <button onClick={() => setMs(ms.filter((_, j) => j !== i))} className="px-2 text-[#968E87] hover:text-red-700" data-testid="timeline-milestone-delete" aria-label="Odstrani"><Trash2 size={16} /></button>
            </div>
          ))}
          <button onClick={() => setMs([...ms, { time: "18:00", title: "Nov mejnik" }])} className="btn-line w-full h-11 text-sm flex items-center justify-center gap-2" data-testid="timeline-add-milestone"><Plus size={16} /> Dodaj mejnik</button>
          <button onClick={save} className="btn-dark w-full h-11 text-sm" data-testid="timeline-save">Shrani časovnico</button>
          <p className="text-xs text-[#968E87]">Časi pred 6:00 zjutraj se štejejo kot nadaljevanje poročne noči.</p>
        </div>
      </div>
      <div className="card-lux p-4 sm:p-6"><Timeline sections={sections} showEmpty title={`Časovnica poroke ${wedding.partner1} & ${wedding.partner2}`} /></div>
    </div>
  );
}
